import { url } from "../../static/env";
import { fetchJsonWithRetry } from "../../utils/fetchWithRetry";

export function getPacks(user_id, pack_type = null, options = {}) {
  const payload = { user_id };
  if (pack_type) payload.pack_type = pack_type;
  return fetchJsonWithRetry(
    url + '/packs',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    { onRetryProgress: options.onRetryProgress }
  )
    .then(({ data }) => {
      console.log('getPacks', data);
      return data;
    })
    .catch(error => {
      console.error('Error fetching packs:', error);
      throw error;
    });
}

export function getPacksUnreadSummary(user_id) {
  return fetch(url + '/packs-unread-summary', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id }),
  })
    .then(response => response.json())
    .catch(error => {
      console.error('Error fetching packs unread summary:', error);
      throw error;
    });
}

export function markPacksViewedUser(user_id, pack_ids) {
  return fetch(url + '/mark-pack-viewed-user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id, pack_ids }),
  })
    .then(response => response.json())
    .catch(error => {
      console.error('Error marking packs viewed for user:', error);
      throw error;
    });
}

export function setBuhBillPaymentClient(user_id, pack_id, client_paid) {
  return fetch(url + '/pack-buh-payment-status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id, pack_id, client_paid: client_paid ? 1 : 0 }),
  })
    .then(async (response) => {
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || 'Не удалось обновить статус оплаты');
      }
      return data;
    });
}

export function createPackFiles(user_id, is_owner, comment, files, pack_type, statement_period, callback) {
  const fileList = Array.isArray(files) ? files : [];
  console.log('createPackFiles file count:', fileList.length, pack_type, statement_period || '');
  let formData = new FormData();

  // Добавляем файлы (как в taskApi: два аргумента — надёжнее в браузере)
  if (fileList.length > 0) {
    fileList.forEach((file, index) => {
      const fileName = file.name || file.filename || `file_${index}`;
      formData.append('files[]', file, fileName);
    });
  }

  // Добавляем остальные поля
  formData.append('user_id', user_id);
  formData.append('is_owner', is_owner ? '1' : '0');
  formData.append('comment', comment || '');
  formData.append('pack_type', pack_type || 'invoices');
  if (statement_period) {
    formData.append('statement_period', statement_period);
  }

  console.log('Uploading pack to:', url);

  fetch(url + '/create-pack-files', {
    method: 'POST',
    body: formData
  })
    .then(async (response) => {
      let data = {};
      try {
        data = await response.json();
      } catch (err) {
        console.warn('create-pack-files: non-JSON body', response.status);
        data = { success: false, error: 'Некорректный ответ сервера' };
      }
      console.log('Upload pack response:', response.status, data);
      if (callback) {
        callback({ ...data, httpOk: response.ok });
      }
    })
    .catch((error) => {
      console.error('Error uploading pack with files:', error);
      if (callback) {
        callback({ success: false, httpOk: false, error: error.message || 'Network error' });
      }
    });
}

